var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"no-options",fn:function(){return [_c('div',{staticClass:"my-no-options-message"},[_vm._v("Nenhum registro encontrado!")])]},proxy:true}])},'v-select',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }